import {
  mappedUpdatesData,
  parsedSheetDataAtom,
  sheetIdAtom,
  treeIdMapAtom,
} from './atoms'
import React, { useMemo, useState } from 'react'
import { TableData } from './types'
import { Box, Button, TextField } from '@mui/material'
import { PotentiallyHtml } from '../../PotentiallyHtml'
import { openNode } from '../../utility/TreeNavigation'
import { Table } from 'shared/ui/Table/Table'
import { useSetAtom, useAtomValue } from 'infrastructure/state/jotai.wrapper'

export function DataTable() {
  const { title } = useAtomValue(parsedSheetDataAtom)
  const dataItems = useAtomValue(mappedUpdatesData)
  const idMap = useAtomValue(treeIdMapAtom)
  const columns = useMemo(() => {
    return [
      {
        title: 'Series Num',
        width: 50,
        rowContent({ seriesId }: TableData) {
          return seriesId
        },
      },
      {
        title: 'Skill Ids',
        width: 100,
        rowContent({ skillNames }: TableData) {
          return <Box>{skillNames.join(', ')}</Box>
        },
      },
      {
        title: 'Node',
        width: 100,
        rowContent({ questionNode }: TableData) {
          return <PotentiallyHtml s={questionNode?.description} />
        },
      },
      {
        title: 'Open',
        width: 50,
        rowContent({ questionNode }: TableData) {
          if (!questionNode) return null
          return (
            <Button onClick={() => openNode(questionNode, idMap)}>Open</Button>
          )
        },
      },
    ]
  }, [idMap])
  return (
    <Box>
      <Table
        title={title}
        columns={columns}
        items={dataItems}
        toolBarItems={[<SheetSelection key="sheetSel" />]}
      />
    </Box>
  )
}

function SheetSelection() {
  const setSheetId = useSetAtom(sheetIdAtom)
  const [editing, setEditing] = useState(false)
  const [enteredText, setEnteredText] = useState('')

  const doneEditing = () => {
    setSheetId(enteredText)
    setEditing(false)
  }
  const onCancel = () => {
    setSheetId('')
    setEditing(false)
  }
  if (editing) {
    return (
      <Box>
        <TextField
          value={enteredText}
          onChange={({ target: { value } }) => setEnteredText(value)}
        />
        <Button onClick={doneEditing}>D</Button>
        <Button onClick={onCancel}>X</Button>
      </Box>
    )
  }
  return <Button onClick={() => setEditing(true)}>X</Button>
}
